/* eslint-disable max-params, no-param-reassign -- these linting errors come up constantly with reducers */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@/store";
import { useAppDispatch } from "@/store/hooks";
import { extraReducersFactory } from "@/store/reducers/reset";

interface HelpCenterState {
  tokenExpiresAt: null | number;
}

const initialState: HelpCenterState = {
  tokenExpiresAt: null,
};

const helpCenterSlice = createSlice({
  // NOTE: extraReducers is required for resetAllReduxSlices to work as expected
  extraReducers: extraReducersFactory(initialState),
  initialState,
  name: "helpCenter",
  reducers: {
    clearTokenExpiresAt: (state) => {
      state.tokenExpiresAt = null;
    },
    setTokenExpiresAt: (state, action: PayloadAction<number>) => {
      state.tokenExpiresAt = action.payload;
    },
  },
});

const {
  clearTokenExpiresAt: clearTokenExpiresAtAction,
  setTokenExpiresAt: setTokenExpiresAtAction,
} = helpCenterSlice.actions;

const selectTokenExpiresAt = (state: RootState) =>
  state.helpCenter.tokenExpiresAt;

const useHelpCenterDispatch = () => {
  const dispatch = useAppDispatch();

  const setTokenExpiresAt = (expiresAt: number) => {
    dispatch(setTokenExpiresAtAction(expiresAt));
  };

  const clearTokenData = () => {
    dispatch(clearTokenExpiresAtAction());
  };

  return {
    clearTokenData,
    setTokenExpiresAt,
  };
};

export { selectTokenExpiresAt, useHelpCenterDispatch };
export default helpCenterSlice.reducer;
